import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class auctionOfferScoreCtrl implements IController {

  offer: any;

  /* @ngInject */
  constructor(private $scope: IScope, private $mdDialog) {
  }

  display(_event) {
    return this.$mdDialog.show({
      template: '<auction-offer-driver-scoring flex layout="column" offer="offer"></auction-offer-driver-scoring>',
      parent: angular.element(document.body),
      scope: _.assign(this.$scope.$new(), {offer: this.offer}),
      targetEvent: _event,
      clickOutsideToClose:true
    });
  }

}

angular
  .module('bringoz.admin.auctions')
  .component('auctionOfferScore', {
    bindings: {
      offer: '<'
    },
    template: require('./auction-offer-score.html').default,
    controller: auctionOfferScoreCtrl
  });


